<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"
                 class="query-form" @submit.native.prevent>
            <el-form-item label="用户">
                <!-- <el-input  v-model="queryForm.userId"></el-input> -->
                <GridSelectU title="选择用户" style="width: 200px;" labelName="userName" labelValue="id"
                             :value="queryForm.userId" :limit='1'
                             size='small' placeholder='请选择用户' @getValue="getSeachValueUser" :columns="USER_code"
                             :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                             queryEntityUrl="/mpp/user/get">
                </GridSelectU>
            </el-form-item>
            <el-form-item label="平台">
                <!-- <el-input style="width: 200px;" v-model="queryForm.platform"></el-input> -->
                <el-select style="width: 200px;" v-model="queryForm.platform" placeholder="请选择平台">
                    <el-option v-for="item in platformList" :key="item.key" :label="item.value"
                               :value="item.key"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="涨关注出价金额">
                <el-input style="width: 200px;" v-model="queryForm.offerPrice"></el-input>
            </el-form-item>
            <el-form-item label="需要涨关注数量">
                <el-input style="width: 200px;" v-model="queryForm.targetFansNumber"></el-input>
            </el-form-item>
            <el-form-item label="已接单任务数量">
                <el-input style="width: 200px;" v-model="queryForm.finishTaskNumber"></el-input>
            </el-form-item>
            <el-form-item label="接单人粉丝要求">
                <el-input style="width: 200px;" v-model="queryForm.acceptFansRequire"></el-input>
            </el-form-item>
            <el-form-item label="接单人作品要求">
                <el-input style="width: 200px;" v-model="queryForm.acceptWorksRequire"></el-input>
            </el-form-item>
            <el-form-item label="任务标题">
                <el-input style="width: 200px;" v-model="queryForm.taskName"></el-input>
            </el-form-item>
            <el-form-item label="任务要关注的账号">
                <!-- <el-input style="width: 200px;" v-model="queryForm.taskAccount"></el-input> -->
                <GridSelectU title="选择账号" style="width: 200px;" labelName="nickName" labelValue="id"
                             :value="queryForm.taskAccount" :limit='1'
                             size='small' placeholder='请选择账号' @getValue="getSeachValueMEDIA" :columns="MEDIA_code"
                             :searchs="MEDIA_search" dataListUrl="/mcn/accountmedia/findList"
                             entityBeanName="mcnAccountMedia" queryEntityUrl="/mcn/accountmedia/get">
                </GridSelectU>
            </el-form-item>
            <el-form-item label="任务要跳转的位置">
                <el-input style="width: 200px;" v-model="queryForm.taskTarget"></el-input>
            </el-form-item>
            <el-form-item label="任务状态">
                <!-- <el-input style="width: 200px;" v-model="queryForm.status"></el-input> -->
                <el-select style="width: 200px;" v-model="queryForm.status" placeholder="请选择">
                    <el-option v-for="item in statusList" :key="item.key" :label="item.value"
                               :value="item.key"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="任务截止日期">
                <el-input style="width: 200px;" v-model="queryForm.deadline"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getMcnTaskFansList">查询
                </el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <!-- <el-button
                      type="primary"
                      size="small"
                      icon="el-icon-plus"
                      @click="addMcnTaskFans"
                    >新建</el-button> -->
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editMcnTaskFans(null)"
                    >修改
                    </el-button>
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteMcnTaskFans(null)"
                    >删除
                    </el-button>
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                               class="upload-demo"
                               action="#"
                               :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
                    <span
                        title="下载模板"
                        class="icon-box"
                        @click="importTemplate"
                    >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
                    <span
                        class="icon-box"
                        title="导入数据"
                        @click="isImport"
                    >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
                    <span
                        title="导出数据"
                        class="icon-box"
                        @click="exportMcnTaskFansList"
                    >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
                    <span
                        class="icon-box"
                        @click="refreshMcnTaskFansList"
                    >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="mcnTaskFansList"
                row-key="id"
                border
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="userId"
                    label="用户"
                    width="180"
                >
                    <template slot-scope='scope'>
                        <div v-if="scope.row.user">
                            <div style='text-align: left'>账号：{{ scope.row.user.userName }}</div>
                            <div style='text-align: left'>手机：{{ scope.row.user.userMobile }}</div>
                            <div style='text-align: left'>昵称：{{ scope.row.user.userNickname }}</div>
                            <div style='text-align: left'>姓名：{{ scope.row.user.userRealname }}</div>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="platform"
                    label="平台"
                    width="180"
                >
                    <template slot-scope='scope'>
                        {{ platformListItem(scope.row.platform) }}
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="status"
                    label="任务状态"
                    width="180"
                >
                    <template slot-scope="scop">
                        {{ statusListItem(scop.row.status) }}
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="offerPrice"
                    label="涨关注出价金额"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="targetFansNumber"
                    label="需要涨关注数量"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="finishTaskNumber"
                    label="已接单任务数量"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="acceptFansRequire"
                    label="接单人粉丝要求"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="acceptWorksRequire"
                    label="接单人作品要求"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="taskName"
                    label="任务标题"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="taskAccount"
                    label="任务要关注的账号"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="taskTarget"
                    label="任务要跳转的位置"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="deadline"
                    label="任务截止日期"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="createTime"
                    label="创建时间"
                    width="180"
                ></el-table-column>
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="300"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkMcnTaskFans(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editMcnTaskFans(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteMcnTaskFans(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="mcnTaskFansStates[mcnTaskFansState]"
                :visible.sync="showDialog"
                width="60%"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="mcnTaskFans"
                        ref="mcnTaskFansForm"
                        :rules="rules"
                        label-width="120px"
                        :inline="true"
                        size="small"
                    >
                        <el-form-item
                            label="用户"
                            prop="userId"
                        >
                            <!-- <el-input
                              size="small"
                              v-model="mcnTaskFans.userId"
                              :disabled="mcnTaskFansState == 'check'"
                            ></el-input> -->
                            <GridSelectU style="width: 200px;" labelName="userName"
                                         :disabled="mcnTaskFansState == 'check'"
                                         labelValue="id" title="选择用户" :value="mcnTaskFans.userId" :limit='1'
                                         size='small' placeholder='请选择用户'
                                         @getValue="getValueUser" :columns="USER_code" :searchs="USER_search"
                                         dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                                         queryEntityUrl="/mpp/user/get">
                            </GridSelectU>
                        </el-form-item>
                        <el-form-item
                            label="平台"
                            prop="platform"
                        >
                            <!-- <el-input
                              size="small"
                              style="width: 200px;"
                              v-model="mcnTaskFans.platform"
                              :disabled="mcnTaskFansState == 'check'"
                            ></el-input> -->
                            <el-select style="width: 200px;" v-model="mcnTaskFans.platform" placeholder="请选择平台"
                                       :disabled="mcnTaskFansState == 'check'">
                                <el-option v-for="item in platformList" :key="item.key" :label="item.value"
                                           :value="item.key"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="涨关注出价金额"
                            prop="offerPrice"
                        >
                            <el-input
                                size="small"
                                style="width: 200px;"
                                v-model="mcnTaskFans.offerPrice"
                                :disabled="mcnTaskFansState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="需要涨关注数量"
                            prop="targetFansNumber"
                        >
                            <el-input
                                size="small"
                                style="width: 200px;"
                                v-model="mcnTaskFans.targetFansNumber"
                                :disabled="mcnTaskFansState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="已接单任务数量"
                            prop="finishTaskNumber"
                        >
                            <el-input
                                size="small"
                                style="width: 200px;"
                                v-model="mcnTaskFans.finishTaskNumber"
                                :disabled="mcnTaskFansState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="接单人粉丝要求"
                            prop="acceptFansRequire"
                        >
                            <el-input
                                size="small"
                                style="width: 200px;"
                                v-model="mcnTaskFans.acceptFansRequire"
                                :disabled="mcnTaskFansState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="接单人作品要求"
                            prop="acceptWorksRequire"
                        >
                            <el-input
                                size="small"
                                style="width: 200px;"
                                v-model="mcnTaskFans.acceptWorksRequire"
                                :disabled="mcnTaskFansState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="任务标题"
                            prop="taskName"
                        >
                            <el-input
                                size="small"
                                style="width: 200px;"
                                v-model="mcnTaskFans.taskName"
                                :disabled="mcnTaskFansState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="任务要关注的账号"
                            prop="taskAccount"
                        >
                            <!-- <el-input
                              size="small"
                              style="width: 200px;"
                              v-model="mcnTaskFans.taskAccount"
                              :disabled="mcnTaskFansState == 'check'"
                            ></el-input> -->
                            <GridSelectU style="width: 200px;" labelName="nickName"
                                         :disabled="mcnTaskFansState == 'check'"
                                         labelValue="id" title="选择账号" :value="mcnTaskFans.taskAccount" :limit='1'
                                         size='small' placeholder='请选择账号'
                                         @getValue="getValueMEDIA" :columns="MEDIA_code" :searchs="MEDIA_search"
                                         dataListUrl="/mcn/accountmedia/findList" entityBeanName="mcnAccountMedia"
                                         queryEntityUrl="/mcn/accountmedia/get">
                            </GridSelectU>
                        </el-form-item>
                        <el-form-item
                            label="任务要跳转的位置"
                            prop="taskTarget"
                        >
                            <el-input
                                size="small"
                                style="width: 200px;"
                                v-model="mcnTaskFans.taskTarget"
                                :disabled="mcnTaskFansState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="任务状态"
                            prop="status"
                        >
                            <!-- <el-input
                              size="small"
                              style="width: 200px;"
                              v-model="mcnTaskFans.status"
                              :disabled="mcnTaskFansState == 'check'"
                            ></el-input> -->
                            <el-select style="width: 200px;" v-model="mcnTaskFans.status" placeholder="请选择"
                                       :disabled="mcnTaskFansState == 'check'">
                                <el-option v-for="item in statusList" :key="item.key" :label="item.value"
                                           :value="item.key"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="任务截止日期"
                            prop="deadline"
                        >
                            <!-- <el-input
                              size="small"
                              style="width: 200px;"
                              v-model="mcnTaskFans.deadline"
                              :disabled="mcnTaskFansState == 'check'"
                            ></el-input> -->
                            <el-date-picker
                                :disabled="mcnTaskFansState == 'check'"
                                size="small"
                                style="width: 200px;"
                                v-model="mcnTaskFans.deadline"
                                type="date"
                                format='yyyy-MM-dd'
                                value-format='yyyy-MM-dd'
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot="footer"
                    class="flex justify-end"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="mcnTaskFansState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import { USER, USER_SEARCH, MEDIA, MEDIA_SEARCH } from '@/utils/constant.js';
import GridSelectU from '@/components/gridselect';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectU
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetMcnTaskFansList();
                this.getMcnTaskFansList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetMcnTaskFansList();
                this.getMcnTaskFansList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm: {
                userId: '', //用户
                platform: '', //平台
                offerPrice: '', //涨关注出价金额
                targetFansNumber: '', //需要涨关注数量
                finishTaskNumber: '', //已接单任务数量
                acceptFansRequire: '', //接单人粉丝要求
                acceptWorksRequire: '', //接单人作品要求
                taskName: '', //任务标题
                taskAccount: '', //任务要关注的账号
                taskTarget: '', //任务要跳转的位置
                status: '', //任务状态
                deadline: '' //任务截止日期
            },
            USER_code: USER,
            USER_search: USER_SEARCH,
            MEDIA_code: MEDIA,
            MEDIA_search: MEDIA_SEARCH,
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            mcnTaskFansState: 'add',
            mcnTaskFansStates: {
                add: '新建涨粉任务',
                check: '查看涨粉任务',
                edit: '修改涨粉任务'
            },
            platformList: [],
            multipleSelection: [],
            mcnTaskFansList: [],
            mcnTaskFans: {
                id: '', //ID
                userId: '', //用户
                platform: '', //平台
                offerPrice: '', //涨关注出价金额
                targetFansNumber: '', //需要涨关注数量
                finishTaskNumber: '', //已接单任务数量
                acceptFansRequire: '', //接单人粉丝要求
                acceptWorksRequire: '', //接单人作品要求
                taskName: '', //任务标题
                taskAccount: '', //任务要关注的账号
                taskTarget: '', //任务要跳转的位置
                status: '', //任务状态
                deadline: '' //任务截止日期
            },
            btnLoading: false,
            statusList: [],
            rules: {
                id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                platform: [{ required: true, message: '平台不能为空', trigger: 'blur' }],
                offerPrice: [{ required: true, message: '涨关注出价金额不能为空', trigger: 'blur' }],
                targetFansNumber: [{ required: true, message: '需要涨关注数量不能为空', trigger: 'blur' }],
                finishTaskNumber: [{ required: true, message: '已接单任务数量不能为空', trigger: 'blur' }],
                acceptFansRequire: [{ required: true, message: '接单人粉丝要求不能为空', trigger: 'blur' }],
                acceptWorksRequire: [{ required: true, message: '接单人作品要求不能为空', trigger: 'blur' }],
                taskName: [{ required: true, message: '任务标题不能为空', trigger: 'blur' }],
                taskAccount: [{ required: true, message: '任务要关注的账号不能为空', trigger: 'blur' }],
                taskTarget: [{ required: true, message: '任务要跳转的位置不能为空', trigger: 'blur' }],
                status: [{ required: true, message: '任务状态不能为空', trigger: 'blur' }],
                deadline: [{ required: true, message: '任务截止日期不能为空', trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getMcnTaskFansList();
        this.getplatformList();
        this.getstatusList();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        getplatformList() {
            get(`/mpp/utils/getEnum`, { enumType: 'mcn_platform_type' }).then((res) => {
                this.platformList = res.enumList;
            });
        },
        getstatusList() {
            get(`/mpp/utils/getEnum`, { enumType: 'mcn_fans_task_status' }).then((res) => {
                this.statusList = res.enumList;
            });
        },
        statusListItem(key) {
            for (const i in this.statusList) {
                if (this.statusList[i].key == key) {
                    return this.statusList[i].value;
                }
            }
        },
        platformListItem(key) {
            for (const i in this.platformList) {
                if (this.platformList[i].key == key) {
                    return this.platformList[i].value;
                }
            }
        },
        resetMcnTaskFansList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.mcnTaskFansList = [];
        },
        // 搜索用户
        getSeachValueUser(value) {
            this.queryForm.userId = value;
        },
        getValueUser(value) {
            this.mcnTaskFans.userId = value;
        },
        getSeachValueMEDIA(value) {
            this.queryForm.taskAccount = value;
        },
        getValueMEDIA(value) {
            this.mcnTaskFans.taskAccount = value;
        },
        resetDialog() {
            this.mcnTaskFansState = 'add';
            this.showDialog = false;
            this.queryForm = {
                userId: '', //用户
                platform: '', //平台
                offerPrice: '', //涨关注出价金额
                targetFansNumber: '', //需要涨关注数量
                finishTaskNumber: '', //已接单任务数量
                acceptFansRequire: '', //接单人粉丝要求
                acceptWorksRequire: '', //接单人作品要求
                taskName: '', //任务标题
                taskAccount: '', //任务要关注的账号
                taskTarget: '', //任务要跳转的位置
                status: '', //任务状态
                deadline: '' //任务截止日期
            };
            this.getMcnTaskFansList();
        },
        closeDialog() {
            this.showDialog = false;
            this.mcnTaskFans = {
                id: '', //ID
                userId: '', //用户
                platform: '', //平台
                offerPrice: '', //涨关注出价金额
                targetFansNumber: '', //需要涨关注数量
                finishTaskNumber: '', //已接单任务数量
                acceptFansRequire: '', //接单人粉丝要求
                acceptWorksRequire: '', //接单人作品要求
                taskName: '', //任务标题
                taskAccount: '', //任务要关注的账号
                taskTarget: '', //任务要跳转的位置
                status: '', //任务状态
                deadline: '' //任务截止日期
            };
        },
        submitForm() {
            if (this.mcnTaskFansState == 'add') {
                this.$refs.mcnTaskFansForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mcn/fans/add`, { ...this.mcnTaskFans }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMcnTaskFansList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.mcnTaskFansState == 'edit') {
                this.$refs.mcnTaskFansForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        delete this.mcnTaskFans.user;
                        post(`/mcn/fans/edit`, { ...this.mcnTaskFans }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMcnTaskFansList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addMcnTaskFans() {
            this.showDialog = true;
            this.mcnTaskFansState = 'add';
        },
        checkMcnTaskFans(mcnTaskFansId) {
            console.log(mcnTaskFansId);
            this.currentMcnTaskFansId = mcnTaskFansId;

            this.getMcnTaskFansById();
            this.showDialog = true;
            this.mcnTaskFansState = 'check';
        },
        editMcnTaskFans(mcnTaskFansId) {
            console.log('mcnTaskFans', mcnTaskFansId);
            if (mcnTaskFansId) {
                this.currentMcnTaskFansId = mcnTaskFansId;
                this.getMcnTaskFansById();
            } else {
                this.mcnTaskFans = { ...this.mcnTaskFans, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.mcnTaskFansState = 'edit';
        },
        deleteMcnTaskFans(mcnTaskFansId) {
            let ids = '';
            if (mcnTaskFansId) {
                ids = mcnTaskFansId;
            } else {
                ids = this.multipleSelection.map((mcnTaskFans) => mcnTaskFans.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/mcn/fans/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetMcnTaskFansList();
                            this.getMcnTaskFansList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshMcnTaskFansList() {
            this.resetMcnTaskFansList();
            this.getMcnTaskFansList();
        },
        getMcnTaskFansList(query = {}) {
            this.loading = true;
            get(`/mcn/fans/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.mcnTaskFansList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getMcnTaskFansById() {
            get(`/mcn/fans/get`, { id: this.currentMcnTaskFansId }).then((res) => {
                if (res.success) {
                    this.mcnTaskFans = { ...this.mcnTaskFans, ...res.mcnTaskFans };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportMcnTaskFansList() {
            //this.btnLoading = true;
            exprotExcel(`/mcn/fans/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/mcn/fans/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/mcn/fans/importData`, formData);
            this.refreshMcnTaskFansList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getMcnTaskFansList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getMcnTaskFansList();
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>